import {villageFeatureKey} from "../../shared/constants";
import {BooleanObservable} from "../../stores/observables/booleanObservable";
import {TextObservable} from "../../stores/observables/textObservable";
import {IUiStore} from "../../stores/uiStore/uiStore";
import {useStores} from "../../stores/useStores";
import {isFeatureToggleEnabled} from "./featureToggle";

export class VillageFeature {
  feature: TextObservable;
  hasFeature: BooleanObservable;

  constructor(uiStore: IUiStore, feature: string) {
    const villageId = uiStore.selectableVillages?.selectedItem?.value;

    this.feature = new TextObservable(
      `${villageFeatureKey}_${feature}_${villageId}`
    );

    if (isFeatureToggleEnabled(feature)) {
      this.hasFeature = new BooleanObservable(true);
    } else {
      this.hasFeature = new BooleanObservable(
        isFeatureToggleEnabled(this.feature.text)
      );
    }
  }
}

export function useVillageFeatureToggle(feature: string) {
  const {uiStore} = useStores();
  const villageFeature = new VillageFeature(uiStore, feature);
  return villageFeature;
}
